var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedTickSquareBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7494 4.47652C22.9446 4.67179 22.9446 4.98837 22.7494 5.18363L12.2715 15.6615C12.0763 15.8567 11.7597 15.8568 11.5645 15.6615L7.10353 11.2019C6.90824 11.0067 6.90819 10.6901 7.10343 10.4948C7.29866 10.2995 7.61524 10.2995 7.81053 10.4947L11.9179 14.6009L22.0423 4.47652C22.2375 4.28126 22.5541 4.28126 22.7494 4.47652Z",
    fill: "#FF0000",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72884 4.14648C5.30892 4.14648 4.90619 4.3133 4.60926 4.61023C4.31232 4.90716 4.14551 5.30989 4.14551 5.72982V19.2715C4.14551 19.6914 4.31232 20.0941 4.60926 20.3911C4.90619 20.688 5.30892 20.8548 5.72884 20.8548H19.2705C19.6904 20.8548 20.0932 20.688 20.3901 20.3911C20.687 20.0941 20.8538 19.6914 20.8538 19.2715V10.071C20.8538 9.79482 21.0777 9.57096 21.3538 9.57096C21.63 9.57096 21.8538 9.79482 21.8538 10.071V19.2715C21.8538 19.9566 21.5817 20.6137 21.0972 21.0982C20.6127 21.5826 19.9557 21.8548 19.2705 21.8548H5.72884C5.0437 21.8548 4.38662 21.5826 3.90215 21.0982C3.41768 20.6137 3.14551 19.9566 3.14551 19.2715V5.72982C3.14551 5.04468 3.41768 4.38759 3.90215 3.90313C4.38662 3.41866 5.0437 3.14648 5.72884 3.14648H19.2054C19.4815 3.14648 19.7054 3.37034 19.7054 3.64648C19.7054 3.92263 19.4815 4.14648 19.2054 4.14648H5.72884Z",
    fill: "#FF0000",
    stroke: "#FF0000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTickSquareBorder);
export default __webpack_public_path__ + "static/media/RedTickSquareBorder.53d7c58515700a734b965381f93ff0fb.svg";
export { ForwardRef as ReactComponent };